<script lang="ts">
  import { faPlus, faRotate } from '@fortawesome/free-solid-svg-icons';
  import { Icon } from 'svelte-awesome';
  import Spinner from '../Spinner.svelte';
  import { DateTime } from 'luxon';

  interface Props {
    isSyncEnabled?: boolean;
    isSynchronizing?: boolean;
    lastSync?: string;
    onAdd?: () => void;
    onSynchronize?: () => void;
  }

  let {
    isSyncEnabled = false,
    isSynchronizing = false,
    lastSync,
    onAdd,
    onSynchronize,
  }: Props = $props();

  const lastSyncText = $derived.by(() => {
    if (!lastSync) {
      return;
    }

    const parsedLastSync = DateTime.fromISO(lastSync);
    if (!parsedLastSync.isValid) {
      return;
    }

    return `Last sync: ${parsedLastSync.toFormat('dd.MM.yyyy, HH:mm')}`;
  });

  function handleAddClick(): void {
    onAdd?.();
  }

  function handleSyncClick(): void {
    if (isSyncEnabled && !isSynchronizing) {
      onSynchronize?.();
    }
  }
</script>

<div class="flex items-end gap-4 fixed z-10 bottom-8 right-8">
  {#if isSyncEnabled}
    <button
      class="btn-icon btn-icon-lg preset-filled-primary-500 shadow-xl"
      title="Synchronize data{lastSyncText ? `\n${lastSyncText}` : ''}"
      onclick={handleSyncClick}
    >
      {#if isSynchronizing}
        <Spinner class="text-white" />
      {:else}
        <Icon data={faRotate} />
        <span class="sr-only"
          >Synchronize data, {#if lastSyncText}
            {lastSyncText}
          {/if}</span
        >
      {/if}
    </button>
  {/if}
  <button
    class="btn-icon btn-icon-lg preset-filled-primary-500 shadow-xl"
    title="Add new entry"
    onclick={handleAddClick}
  >
    <Icon data={faPlus} />
    <span class="sr-only">Add new entry</span>
  </button>
</div>
